import { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, Upload, Smartphone } from "lucide-react";
import { toast } from "sonner";

// ACUTO PDKS Android APK — herkes için tek dosya; yalnız süper yönetici yükler
export function PdksApkCard() {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const [version, setVersion] = useState("");
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);
  const load = () => api.get("/pdks/mobile/app-info").then(({ data }) => setInfo(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!user?.is_super_admin) return null;

  const upload = async () => {
    const f = fileRef.current?.files?.[0];
    if (!f || !version.trim()) { toast.error("APK dosyası ve sürüm gerekli"); return; }
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f); fd.append("version", version.trim());
      await api.post("/pdks/mobile/apk", fd);
      toast.success("ACUTO PDKS APK yüklendi"); setVersion(""); fileRef.current.value = ""; load();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <Card className="bg-slate-900 border-slate-800 rounded-sm p-5 space-y-3" data-testid="pdks-apk-card">
      <div className="flex items-center gap-2 text-sm font-semibold"><Smartphone className="w-4 h-4 text-blue-400" />ACUTO PDKS Android Uygulaması (APK)</div>
      <div className="text-xs text-slate-400" data-testid="pdks-apk-status">
        {info?.apk_available ? `Yayında: v${info.version} · ${(info.size / 1048576).toFixed(1)} MB · ${new Date(info.uploaded_at).toLocaleString("tr-TR")}`
          : "Henüz APK yüklenmedi — personel kurulumu Chrome üzerinden (Uygulamayı Yükle) yapılır."}
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <Input ref={fileRef} type="file" accept=".apk" className="h-9 text-xs w-64" data-testid="pdks-apk-file" />
        <Input value={version} onChange={(e) => setVersion(e.target.value)} placeholder="Sürüm (örn. 1.0.0)" className="h-9 text-xs w-36" data-testid="pdks-apk-version" />
        <Button size="sm" className="h-9" onClick={upload} disabled={busy} data-testid="pdks-apk-upload">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Upload className="w-3.5 h-3.5 mr-1" />Yükle</>}
        </Button>
      </div>
    </Card>
  );
}
